interface DayLabelProps {
    day: string;
    /** Drops the extra top padding for the very first label in the list. */
    first: boolean;
}

// Day separator - the dot sits in the same w-10 column as the spine's
// medallions above it. Dot + date only, no trailing hairline.
export function DayLabel({ day, first }: DayLabelProps) {
    return (
        <div className={`flex items-center gap-3 ${first ? '' : 'pt-1'} pb-4`}>
            <span className="w-10 flex justify-center shrink-0">
                <span className="w-1.5 h-1.5 rounded-full bg-gray-300" />
            </span>
            <span className="text-[12px] font-bold text-gray-500">{day}</span>
        </div>
    );
}
